import { render, staticRenderFns } from "./DataIndukProgram.vue?vue&type=template&id=f2596d78"
import script from "./DataIndukProgram.vue?vue&type=script&lang=js"
export * from "./DataIndukProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports